import React from 'react';
import fr from 'facet-rest';
import { useWidth } from 'Hooks/useDimensions';
import { FDBox, FDIcon } from '@facet-wealth/design';
import PropTypes from 'prop-types';
import { TextButtonRel } from 'Packages/FacetCore/Experimental/RelationshipComponents/TextButtonRel';
import { useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { dataAttrs } from 'Helpers/Testing';

export const WorkflowNavigation = ({ resource }) => {
  const [stackRef, stackWidth] = useWidth();
  const theme = useTheme();

  return (
    <div
      style={{
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: theme.spacing(2, 2, 0),
      }}
      ref={stackRef}
    >
      <FDBox>
        {resource.withRelationship(fr.relationships.previousLink.name, (rel) => {
          return (
            <TextButtonRel relationship={rel} {...dataAttrs('back-btn')} />
          );
        }, () => null)}
      </FDBox>
      {stackWidth > theme.dimensions.sm ? (
        <div style={{
          position: 'absolute',
          transform: 'translateX(-50%)',
          left: '50%',
        }}
        >
          <FDIcon alignSelf={'center'} icon={'fac'} />
        </div>
      ) : null}
      <FDBox>
        {resource.withRelationship(fr.relationships.exit.name, (rel) => {
          return (
            <TextButtonRel relationship={rel} {...dataAttrs('exit-btn')} />
          );
        }, () => null)}
      </FDBox>
    </div>
  );
};

WorkflowNavigation.propTypes = {
  resource: PropTypes.object.isRequired,
};
